/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import home_1 from "../../assets/images/pictures/home_1.png";
import home_2 from "../../assets/images/pictures/home_2.png";

import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import routeVariants from "./../../assets/animates/routeVariants";
import Footer from "../global/Footer";
import NavbarBottom from "../global/NavbarBottom";
import FPT_CA from "../../assets/images/logos/CA/FPT-CA.png";
import FAST_CA from "../../assets/images/logos/CA/FastCA.png";
import WIN_CA from "../../assets/images/logos/CA/WIN_Ca.png";
import CMC_CA from "../../assets/images/logos/CA/cmcca1.png";
import EASY_CA from "../../assets/images/logos/CA/easyca.png";
import I_CA from "../../assets/images/logos/CA/i-ca.png";
import NC_CA from "../../assets/images/logos/CA/ncca.png";
import VG_CA from "../../assets/images/logos/CA/vgca.png";
import VIETTEL_CA from "../../assets/images/logos/CA/viettel-ca.png";
import BKAV_CA from "../../assets/images/logos/CA/bkav-ca.png";
import VNPT_CA from "../../assets/images/logos/CA/vnpt-ca.png";
import EFY_CA from "../../assets/images/logos/CA/logo_efy.png";
import NACENCOMM from "../../assets/images/logos/CA/Untitled-removebg-preview.png";
import SMART_SIGN from "../../assets/images/logos/CA/smart-sign.png";
import SAFE_CA from "../../assets/images/logos/CA/safe-ca.png";
import TRUST_CA from "../../assets/images/logos/CA/trustca.png";
import MISA_ESIGN from "../../assets/images/logos/CA/misaca.png";
import LCS_CA from "../../assets/images/logos/CA/lcsca.png";
import NEWTEL_CA from "../../assets/images/logos/CA/newtelca.png";
import HILO_CA from "../../assets/images/logos/CA/hilo-ca.svg";
import mobi_CA from "../../assets/images/logos/CA/svg.svg";
import matbao_CA from "../../assets/images/logos/CA/matbao_CA.png";
import vnpay_CA from "../../assets/images/logos/CA/vnpay_CA.png";
import eca from "../../assets/images/logos/CA/Logo_ECA.svg";

const HomeContent = () => {
  const { t, i18n } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 bg-color-main no-transform"
    >
      <div className="container-fluid bg-color-home pt-73 pb-73">
        <div className="container px-md-0">
          <div className="col-sm-7 px-md-0">
            <h1 className="font-weight-bold font-60 text-white text-xs-center">
              {t("home-page.home-content.content-1")}
            </h1>
            <p className="text-white text-xs-center mx-auto">
              {t("home-page.home-content.content-2")}
            </p>
            <p className="text-white text-xs-center pb-50">
              {t("home-page.home-content.content-2-1")}
            </p>
            <p className="text-xs-center pb-xs-20">
              <a
                className="btn-secondary background-size-none"
                href={`https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
                  i18n.language || "vi"
                }`}
                target="_blank"
                rel="noreferrer"
              >
                {t("home-page.home-footer.button-signing")}
              </a>
            </p>
          </div>
          <div className="col-sm-5 px-md-0">
            <div className="col-12">
              <img
                className="img-responsive mr-0"
                width="550px"
                src={home_1}
                data-no-retina
                alt="connection"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fuild flex center">
        <div className="triangle-middle-bottom"></div>
      </div>

      <h1 className="font-weight-bold text-center font-48">
        {t("home-page.home-content.content-5")}
      </h1>
      <div className="container">
        <div className="row pt-10">
          <div className="col-sm-6 col-12">
            <img
              className="img-responsive"
              width="450px"
              src={home_2}
              data-no-retina
              alt="connection"
            />
          </div>
          <div className="col-sm-6 col-12 text-xs-center">
            <p className="mb-25">{t("home-page.home-content.content-6")}</p>
            <div className="btn-box btn-xs-center btn-sm-start btn-md-start">
              <a href="/features" className="btn-primary">
                {t("home-page.home-content.button-learnmore")}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="container pt-30 pb-30">
        <div className="row">
          <div className="col-sm-12 text-center">
            <p className="companies-text d-inline-block text-truncate d-sm-block">
              {t("home-page.home-content.content-7")}
            </p>
            <ul className="list-inline text-center m-0">
              <li>
                <img
                  alt="FPT-CA"
                  title="FPT-CA"
                  className="client-s"
                  src={FPT_CA}
                />
              </li>
              <li>
                <img
                  alt="VIETTEL-CA"
                  title="VIETTEL-CA"
                  className="client-s"
                  src={VIETTEL_CA}
                />
              </li>
              <li>
                <img
                  alt="BKAV-CA"
                  title="BKAV-CA"
                  className="client-s"
                  src={BKAV_CA}
                />
              </li>
              <li>
                <img
                  alt="VNPT-CA"
                  title="VNPT-CA"
                  className="client-s"
                  src={VNPT_CA}
                />
              </li>
              <li>
                <img
                  alt="EFY-CA"
                  title="EFY-CA"
                  className="client-s"
                  src={EFY_CA}
                />
              </li>
              <li>
                <img
                  style={{ height: "50px" }}
                  alt="NACENCOMM-CA"
                  title="NACENCOMM-CA"
                  className="client-s"
                  src={NACENCOMM}
                />
              </li>
              <li>
                <img
                  alt="SMART-SIGN-CA"
                  title="SMART-SIGN-CA"
                  className="client-s"
                  src={SMART_SIGN}
                />
              </li>
              <li>
                <img
                  alt="SAFE-CA"
                  title="SAFE-CA"
                  className="client-s"
                  src={SAFE_CA}
                />
              </li>
              <li>
                <img
                  alt="TRUST-CA"
                  title="TRUST-CA"
                  className="client-s"
                  src={TRUST_CA}
                />
              </li>
              <li>
                <img
                  alt="MISA-CA"
                  title="MISA-CA"
                  className="client-s"
                  src={MISA_ESIGN}
                />
              </li>
              <li>
                <img alt="NCCA" title="NCCA" className="client-s" src={NC_CA} />
              </li>
              <li>
                <img
                  alt="CMC-CA"
                  title="CMC-CA"
                  className="client-s"
                  src={CMC_CA}
                />
              </li>
              <li>
                <img
                  alt="LCS-CA"
                  title="LCS-CA"
                  className="client-s"
                  src={LCS_CA}
                />
              </li>
              <li>
                <img
                  alt="EASY-CA"
                  title="EASY-CA"
                  className="client-s"
                  src={EASY_CA}
                />
              </li>
              <li>
                <img
                  alt="NEWTEL-CA"
                  title="NEWTEL-CA"
                  className="client-s"
                  src={NEWTEL_CA}
                />
              </li>
              <li>
                <img alt="I-CA" title="I-CA" className="client-s" src={I_CA} />
              </li>
              <li>
                <img
                  alt="HILO-CA"
                  title="HILO-CA"
                  className="client-s"
                  src={HILO_CA}
                />
              </li>

              <li>
                <img
                  alt="FAST-CA"
                  title="FAST-CA"
                  className="client-s"
                  src={FAST_CA}
                />
              </li>
              <li>
                <img
                  alt="WIN-CA"
                  title="WIN-CA"
                  className="client-s"
                  src={WIN_CA}
                />
              </li>
              <li>
                <img
                  alt="matbao_CA"
                  title="matbao_CA"
                  className="client-s"
                  src={matbao_CA}
                />
              </li>
              <li>
                <img
                  alt="mobi_CA"
                  title="mobi_CA"
                  className="client-s"
                  src={mobi_CA}
                />
              </li>
              <li>
                <img
                  alt="ECA_CA"
                  title="ECA_CA"
                  className="client-s"
                  src={eca}
                />
              </li>
              <li>
                <img
                  alt="vnpay_CA"
                  title="vnpay_CA"
                  className="client-s"
                  src={vnpay_CA}
                />
              </li>
              <li>
                <img alt="VGCA" title="VGCA" className="client-s" src={VG_CA} />
              </li>

              {/* <li>
                <img
                  alt="vnpay_CA"
                  title="vnpay_CA"
                  className="client-s"
                  src={vnpay_CA}
                />
              </li> */}
            </ul>
          </div>
        </div>
      </div>

      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default HomeContent;
